import APIService from '../../../../Services/APIService';

const required = (value, label) => {
  if (value === undefined || value === null || value === '') {
    throw new Error(`${label} is required`);
  }
  return encodeURIComponent(String(value));
};

export const formStudioService = {
  listForms(campaignId, options = {}) {
    return APIService.get(
      `v0/ui/leads/${required(campaignId, 'Campaign ID')}/form`,
      options
    );
  },

  async getForm(campaignId, formId, options = {}) {
    const response = await this.listForms(campaignId, options);
    const forms = response?.data ?? {};
    const form =
      forms?.[formId] ??
      forms?.[String(formId)] ??
      Object.values(forms).find(
        (item) => String(item?.leads_form_id) === String(formId)
      );
    return { ...response, data: form };
  },

  createForm(campaignId, payload) {
    return APIService.post(`/v0/ui/leads/${required(campaignId, 'Campaign ID')}/create`, payload);
  },

  updateForm(formId, payload) {
    return APIService.put(
      `/v0/ui/leads/${required(formId, 'Form ID')}/edit_form`,
      payload
    );
  },

  deleteForm(formId) {
    return APIService.put(
      `/v0/ui/leads/${required(formId, 'Form ID')}/delete_form`,
      {}
    );
  },

  deleteField(formId, itemId) {
    return APIService.put(
      `/v0/ui/leads/${required(formId, 'Form ID')}/delete_form_element/${required(
        itemId,
        'Item ID'
      )}`,
      {}
    );
  },
};

export default formStudioService;
